<script>
	import SimpleFooter from "../common/SimpleFooter.svelte";
	import Encrypter from "./Encrypter.svelte";
	import LangModal from "../home/LangModal.svelte";

	const locals = {
		en: "en",
		bg: "bg",
	};

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let local = urlParams.get("l") || urlParams.get("lang") || navigator.language; //defaults to user's language if no language is set via link parameters
	export let hasPrefLangSet = false;
	export let lang = checkPreferedLang();

	function checkPreferedLang() {
		if (localStorage.getItem("hasPreferedLang") === null) {
			hasPrefLangSet = false;
			return locals[local] || "bg"; //defaults to ~english~ BULGARIAN if the user's language or the link param. language is not in the list
		} else {
			if (localStorage.getItem("preferedLanguage") !== null) {
				hasPrefLangSet = true;
				return localStorage.getItem("preferedLanguage");
			}
		}
	}

	function setLang(l) {
		localStorage.setItem("hasPreferedLang", true);
		localStorage.setItem("preferedLanguage", l);
		lang = l;
	}

	function handleSetLang(event) {
		setLang(event.detail.lang);
		hasPrefLangSet = event.detail.prefset;
	}
</script>

<svelte:head>
	<html {lang} />
	<title
		>{lang == "bg"
			? "Закодиране | Вътрешен глас"
			: "Encrypter | Inner Voice"}</title
	>
	<meta name="mobile-web-app-title" content="Encrypt @ VutreshenGlas.com" />
</svelte:head>

<LangModal on:setLang={handleSetLang} {lang} {hasPrefLangSet} />
<Encrypter {lang} />
<SimpleFooter on:setLang={handleSetLang} {lang} />
